'use strict';

module.exports = require('./Progress');


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-progress/lib/index.js
 ** module id = 337
 ** module chunks = 0
 **/